import { render, staticRenderFns } from "./AdibDetail.vue?vue&type=template&id=53d8b524&scoped=true"
import script from "./AdibDetail.vue?vue&type=script&lang=js"
export * from "./AdibDetail.vue?vue&type=script&lang=js"
import style0 from "./AdibDetail.vue?vue&type=style&index=0&id=53d8b524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8b524",
  null
  
)

export default component.exports